var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "centered": "",
      "no-close-on-backdrop": "",
      "no-fade": "",
      "hide-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-title",
      fn: function fn() {
        return [_c('div', {
          staticClass: "title"
        }, [_vm._v(" " + _vm._s(_vm.tt('물품 ID 스티커 출력')) + " ")])];
      },
      proxy: true
    }])
  }, [[_c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "describe",
    domProps: {
      "innerHTML": _vm._s(_vm.tt('안전법령에 의해, GHS라벨+QR스티커는 용량에 따라 지정된 법령규격으로 출력합니다.<br />라벨을 프린트할 용지를 프린트에 넣고 인쇄해주세요.'))
    }
  }), _c('a', {
    staticClass: "link",
    attrs: {
      "target": "_blank",
      "href": "https://www.law.go.kr/LSW/admRulLsInfoP.do?admRulSeq=2100000049106"
    }
  }, [_vm._v("※ " + _vm._s(_vm.tt('「위험물안전관리법」시행규칙 별표 19')))]), _c('table', [_c('thead', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.tt('타입')))]), _c('td', [_vm._v(_vm._s(_vm.tt('사이즈')))]), _c('td', [_vm._v(_vm._s(_vm.tt('스티커 규격')))]), _c('td', [_vm._v(_vm._s(_vm.tt('출력할 용지')))]), _c('td', [_vm._v(_vm._s(_vm.tt('출력 기기')))])])]), _c('tbody', [_c('tr', [_c('td', [_vm._v("QR")]), _c('td', [_vm._v(_vm._s(_vm.tt('전체')))]), _c('td', [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.tt('1칸')) + " ")]), _c('p', [_vm._v("24.5mm x 100mm")])])]), _c('td', [_vm._v(_vm._s(_vm.tt('폼텍 3219')))]), _c('td', [_vm._v(_vm._s(_vm.tt('일반 프린터')))])]), _c('tr', [_c('td', [_vm._v("GHS+QR")]), _c('td', [_vm._v(_vm._s(_vm.tt('500L 이상')))]), _c('td', [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.tt('1칸')) + " ")]), _c('p', [_vm._v("297mm x 210mm")])])]), _c('td', [_vm._v(_vm._s(_vm.tt('폼텍 3130')))]), _c('td', [_vm._v(_vm._s(_vm.tt('일반 프린터')))])]), _c('tr', [_c('td', [_vm._v("GHS+QR")]), _c('td', [_vm._v(_vm._s(_vm.tt('200L ≤ 용량 < 500L')))]), _c('td', [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.tt('1칸')) + " ")]), _c('p', [_vm._v("297mm x 210mm")])])]), _c('td', [_vm._v(_vm._s(_vm.tt('폼텍 3130')))]), _c('td', [_vm._v(_vm._s(_vm.tt('일반 프린터')))])]), _c('tr', [_c('td', [_vm._v("GHS+QR")]), _c('td', [_vm._v(_vm._s(_vm.tt('50L ≤ 용량 < 200L')))]), _c('td', [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.tt('2칸')) + " ")]), _c('p', [_vm._v("200mm x 140mm")])])]), _c('td', [_vm._v(_vm._s(_vm.tt('폼텍 3120')))]), _c('td', [_vm._v(_vm._s(_vm.tt('일반 프린터')))])]), _c('tr', [_c('td', [_vm._v("GHS+QR")]), _c('td', [_vm._v(_vm._s(_vm.tt('전체')))]), _c('td', [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.tt('4칸')) + " ")]), _c('p', [_vm._v("140mm x 99.1mm")])])]), _c('td', [_vm._v(_vm._s(_vm.tt('폼텍 3118')))]), _c('td', [_vm._v(_vm._s(_vm.tt('일반 프린터')))])]), _c('tr', [_c('td', [_vm._v("GHS+QR")]), _c('td', [_vm._v(_vm._s(_vm.tt('전체')))]), _c('td', [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.tt('8칸')) + " ")]), _c('p', [_vm._v("99.1mm x 67.7mm")])])]), _c('td', [_vm._v(_vm._s(_vm.tt('폼텍 3114')))]), _c('td', [_vm._v(_vm._s(_vm.tt('일반 프린터')))])])])])])]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }